module.exports = __webpack_public_path__ + "static/media/radioDark.f2352349.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/Header/components/Title/Icons/radioDark.svg
// module id = 79
// module chunks = 0